import React from 'react';
import { Image, Text, View } from 'react-native';
import {
  add_recipient, img_icon_add_circle, img_icon_search, img_icon_search_x,
} from '../../utils/ImagesManagementUtils';
import { textPrimary_11_0 } from '../SimulatorsComponents/AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================

const SearchContactHeadLine = ({
  globJSON,
  simPlatform,
  subCategoryId,
  withCloseIcon,
  text,
  textBlack,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { recipient } = globJSON.configurations.services[subCategoryId];

  const myStyles = {
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 10,
      marginBottom: 6,
    },
    textInputStyle: {
      width: recipient.add_recipient_manually ? 195 : 222,
      height: 24,
      backgroundColor: colors.light_elements_color,
      borderRadius: 6,
      paddingVertical: 6,
      paddingHorizontal: 4,
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    hintStyle: {
      color: textBlack ? '#001a2f' : colors.secondary_font_color,
      alignSelf: 'center',
    },
    searchImage: {
      width: 18,
      height: 18,
      tintColor: colors.secondary_font_color,
      alignSelf: 'center',
    },
    addImage: {
      width: 18,
      height: 18,
      tintColor: colors.links_icons_color,
      alignSelf: 'center',
    },
    xIconStyle: {
      width: 12,
      height: 12,
    },
    row: {
      flexDirection: 'row',
    },
  };
  return (
    <View style={myStyles.container}>
      <View style={myStyles.textInputStyle}>
        <View style={myStyles.row}>
          <Image
            fadeDuration={0}
            style={myStyles.searchImage}
            source={img_icon_search}
          />
          <Text style={[textPrimary_11_0(globJSON, simPlatform), myStyles.hintStyle]}>
            {text}
          </Text>
        </View>
        {withCloseIcon && (
          <Image
            fadeDuration={0}
            style={myStyles.xIconStyle}
            source={img_icon_search_x}
          />
        )}
      </View>
      {recipient.add_recipient_manually
      && (
        <Image
          fadeDuration={0}
          style={myStyles.addImage}
          source={recipient.contact_image === 'contact' ? add_recipient : img_icon_add_circle}
        />
      )}
    </View>
  );
};
export default SearchContactHeadLine;
